import React from "react";
import { useNavigate } from "react-router-dom";
const BlogItem = ({ item }) => {
  const navigate = useNavigate();
  const handleBlogClick = () => {
    navigate(`/${item?.slug}`);
  };
  return (
    <div className="blog" onClick={() => handleBlogClick()}>
      <div className="content">
        <div className="overflowWrap">
          <h3>{item?.title}</h3>
           <p
            dangerouslySetInnerHTML={{ __html: item?.content }}
            style={{ textAlign: "justify" }}
          />
        </div>
        <div  className="img-container">
        
          <img src={item?.image?.image} />
        </div>
      </div>
      <div className="bottom">
        <div>
          <span className="topic">#{item?.category?.title}</span>
        </div>
      </div>
    </div>
  );
};

export default BlogItem;
